import { Injectable } from '@angular/core';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { API } from '../config/api';
import { tap, catchError } from 'rxjs/operators';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { HxNotification, HxQuote} from 'src/@core/models/hx';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
//import { SignalRService } from '../signalR';

//import { QuotationsSharedService} from './quotationsShared.service';

@Injectable()
export class HxNotificationsService {
  public objecMenu = new BehaviorSubject('');
  public quoteAllBooked = new Subject<any>();
  

  constructor(private _http: HttpClient,
    private _spinner: BoSpinnerService,
    private _toastr: BoToastrService,
    private authService: AuthService,
  ) {    
  }  

  
  public getHxNotifications(): Observable<HxNotification[]> {
    if (!this.authService.IsAuthenticate) {
      return;
    }
    return this._http.get<HxNotification[]>(`${API.HX.GET_NOTIFICATIONS}`);
  }

  public ackHxNotification(notificationId) {
    return this._http.put(`${API.HX.ACK_NOTIFICATION}/` + notificationId, "")
      .pipe(tap(() => {
        this._spinner.hide();
        if (!document.getElementById("notifications-menu").classList.contains('show'))
          document.getElementById("notifications-menu").classList.add('show');
      }));
  }

     
  
}
